import { Col, Row } from 'antd';
import {
  CustomTable,
  CustomText,
  CustomTextArea,
  FormSelect,
} from '../../../../../components';
import React from 'react';
import { ColumnsType } from 'antd/es/table';

const ManageOneAsset = ({ formik, itemSelected }: any) => {
  React.useEffect(() => {}, itemSelected);
  const columnsActivo: ColumnsType = [
    {
      title: 'Item',
      dataIndex: 'id',
      key: 'id',
      render: (item) => {
        return item ? item : 'Sin registro';
      },
    },
    {
      title: 'Código/placa',
      dataIndex: 'plate_code',
      key: 'plate_code',
      render: (item) => {
        return item ? item : 'Sin registro';
      },
    },
    {
      hidden: itemSelected.class ? true : false,
      title: 'Descripción',
      dataIndex: 'description',
      key: 'description',
      render: (item) => {
        return item ? item : 'Sin registro';
      },
    },
    {
      hidden: itemSelected.class ? false : true,
      title: 'Descripción',
      dataIndex: 'asset',
      key: 'asset',
      render: (item) => {
        return item ? item : 'Sin registro';
      },
    },
    {
      hidden: itemSelected.class ? true : false,
      title: 'Clase de activo',
      dataIndex: 'asset_class',
      key: 'asset_class',
      render: (item) => {
        return item && item.name
          ? `${item.code} - ${item.name}`
          : 'Sin registro';
      },
    },
    {
      hidden: itemSelected.class ? false : true,
      title: 'Clase de activo',
      dataIndex: 'class',
      render: (item) => {
        return item && item.name
          ? `${item.code} - ${item.name}`
          : 'Sin registro';
      },
    },
    {
      title: 'Artículo',
      dataIndex: 'item',
      key: 'item',
      render: (item) => {
        return item && item.name
          ? `${item.code} - ${item.name}`
          : 'Sin registro';
      },
    },
    {
      title: 'Adiciones',
      dataIndex: 'assets',
      key: 'assets',
      render: (item) => {
        return item && item.length > 0 ? item.length : '0';
      },
    },
    {
      hidden: itemSelected.good_status ? false : true,
      title: 'Estado del bien',
      dataIndex: 'good_status',
      key: 'good_status',
      render: (item) => {
        return item && item.status ? item.status : 'Sin registro';
      },
    },
    {
      hidden: itemSelected.good_status ? true : false,
      title: 'Estado del bien',
      dataIndex: 'asset_good_status',
      key: 'asset_good_status',
      render: (item) => {
        return item && item.status ? item.status : 'Sin registro';
      },
    },
  ];
  const columnsAdiciones: ColumnsType = [
    {
      title: 'Item',
      dataIndex: 'id',
      key: 'id',
      render: (item) => {
        return item ? item : 'Sin registro';
      },
    },
    {
      title: 'Codigo placa',
      dataIndex: 'plate_code',
      key: 'plate_code',
      render: (item) => (item ? item : 'Sin registro'),
    },
    {
      title: 'Descripción',
      dataIndex: 'description',
      key: 'description',
      render: (item) => (item ? item : 'Sin registro'),
    },
    {
      title: 'Clase de activos',
      dataIndex: 'asset_class',
      key: 'asset_class',
      render: (item) => {
        return item && item.name
          ? `${item.code} - ${item.name}`
          : 'Sin registro';
      },
    },
    {
      title: 'Artículo',
      dataIndex: 'item',
      key: 'item',
      render: (item) => {
        return item && item.name
          ? `${item.code} - ${item.name}`
          : 'Sin registro';
      },
    },
    {
      title: 'Estado del bien',
      dataIndex: 'good_status',
      key: 'good_status',
      render: (item) => (item && item.status ? item.status : 'Sin registro'),
    },
    
  ];
  return (
    <>
      <Row style={{ marginBottom: '20px' }}>
        <Col xs={24}>
          <CustomText fontSize="big" text="Activo principal" />
          <CustomTable
            columns={columnsActivo.filter(
              (column: any) => column.title !== 'Acciones'
            )}
            dataSource={[itemSelected]}
            scroll={{ x: 'max-content' }}
          />
        </Col>
      </Row>
      {itemSelected?.assets && itemSelected?.assets?.length > 0 && (
        <Row style={{ marginBottom: '20px' }}>
          <Col xs={24}>
            <CustomText fontSize="big" text="Adiciones" />
            <CustomTable
              columns={columnsAdiciones}
              dataSource={itemSelected.assets}
              scroll={{ x: 'max-content' }}
            />
          </Col>
        </Row>
      )}
      {!!formik && (
        <>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={8}>
              <FormSelect
                label="Estado del elemento"
                name="status_id"
                placeholder="Seleccione"
                value={formik.values.status_id}
                options={[
                  {
                    name: 'Recibido',
                    id: '15',
                  },
                  {
                    name: 'Rechazado',
                    id: '10',
                  },
                ]}
                error={formik.errors.status_id}
                touched={formik.touched.status_id}
                onChange={(value) => formik.setFieldValue('status_id', value)}
                onBlur={formik.handleBlur}
              />
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <CustomTextArea
                label="Observaciones"
                name="observationsItem"
                placeholder="Observaciones"
                value={formik.values.observationsItem}
                error={formik.errors.observationsItem}
                touched={formik.touched.observationsItem}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                maxLength={501}
              />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default ManageOneAsset;
